import React from "react";
import MultiSelect from "./partials/MultiSelect";
import Sort from "./partials/Sort";
import Referrers from "./partials/Referrers";
import TimeWindow from "./partials/TimeWindow";
import PubDateTimeWindow from "./partials/PubDateTimeWindow";
import PaidType from "./partials/PaidType";
import Sections from "./partials/Sections";
import Label from "./partials/Label";
import ShowCircles from "./partials/ShowCircles";
import HomePage from "./partials/HomePage";
import VideoFilter from "./partials/VideoFilter";
import WeightedResult from "./partials/WeightedResult";
import {IGridConfigItem} from "../../../constants/interfaces";
import PostedOnChannel from "./partials/PostedOnChannel";
import Tags from "./partials/Tags";
import ConversionFilter from "./partials/ConversionFilter";
import PageType from "./partials/PageType";
import UserNeeds from "./partials/UserNeeds";
import useCurrentBrandsBigscreenSettings from "../../../hooks/useCurrentBrandsBigscreenSettings";

type Props = {
    item: IGridConfigItem,
    updateConfig: Function,
    isEdit: boolean,
    removeItem: React.MouseEventHandler<HTMLButtonElement>,
    id: number
}

const List = (props: Props) => {
    const currentBigscreenSettings = useCurrentBrandsBigscreenSettings(props.item.brands);

    const isFieldSelected = (fieldName: string) => {
        if (props.item.sort && props.item.sort.indexOf(fieldName) === 0) {
            return true;
        }

        if (props.item.fields && props.item.fields.indexOf(fieldName) !== -1) {
            return true;
        }

        return false;
    }

    const getTimeFrameType = () => {
        if (isFieldSelected("averageReadDepth") || isFieldSelected("averageScrollDepth")) {
            return '12hours';
        }

        if (isFieldSelected('totalReadingTime') || isFieldSelected('averageReadingTime')) {
            return 'from5min';
        }

        return 'default';
    };
    
    return (
        <div className="config-item__list">
            <h2>Story list</h2>
            <MultiSelect
				updateConfig={props.updateConfig}
				selectedColumns={props.item.fields}
                initialEventFields={props.item.event_fields}
                initialCustomFields={props.item.custom_fields}
				type="list"
                brands={props.item.brands}
                bigscreenSettings={currentBigscreenSettings}
				isEdit={props.isEdit}
			/>
            <Sort 
                bigscreenSettings={currentBigscreenSettings}
                updateConfig={props.updateConfig} 
                value={props.item.sort}
            />

            <div className="config-item__selects">
                <TimeWindow 
                    updateConfig={props.updateConfig} 
                    timeWindow={props.item.time_window} 
                    timeFrameType={getTimeFrameType()} 
                />
                <PubDateTimeWindow
                    updateConfig={props.updateConfig}
                    pubDateInterval={props.item.pubdate_interval}
                />
            </div>
			<div className="config-item__selects">
                <UserNeeds
                    updateConfig={props.updateConfig}
					userNeedValues={props.item.user_needs}
                />
            </div>

            <Sections
				updateConfig={props.updateConfig}
                sections={props.item.sections}
				brands={props.item.brands}
				type="feed"
				isEdit={props.isEdit}
				cellId={props.item.cell_id}
				id={props.id}
			/>

            <div className="config-item__selects">
                <Tags
                    updateConfig={props.updateConfig}
                    tags={props.item.tags}
                    brands={props.item.brands}
                    type="feed"
                    isEdit={props.isEdit}
                    isDisabled={props.item.brands.length === 0}
                    cellId={props.item.cell_id}
                    id={props.id}
                />
                <ConversionFilter 
                    updateConfig={props.updateConfig}
                    conversions={props.item.conversions}
                    brands={props.item.brands}
                    type="feed"
                    isEdit={props.isEdit}
                    isDisabled={props.item.brands.length === 0}
                    cellId={props.item.cell_id}
                    id={props.id}
                />
            </div>

            <Referrers 
                updateConfig={props.updateConfig}
                referrerTypes={props.item.referrer_types}
                referrers={props.item.referrers}
                brands={props.item.brands}
                isEdit={props.isEdit}
                isDisabled={props.item.brands.length === 0}
                cellId={props.item.cell_id}
                id={props.id}
            />

            <div className="config-item__selects">
                <PaidType updateConfig={props.updateConfig} value={props.item.paid_type} />
                <VideoFilter updateConfig={props.updateConfig} value={props.item.video_filter} />
                <PageType updateConfig={props.updateConfig} value={props.item.page_type} />
            </div>
            
            <PostedOnChannel 
                isEdit={props.isEdit}
                postedOnChannels={props.item.posted_on_channels}
                updateConfig={props.updateConfig}
            />

            <ShowCircles item={props.item} updateConfig={props.updateConfig}/>
            <HomePage item={props.item} updateConfig={props.updateConfig} />
            <WeightedResult item={props.item} updateConfig={props.updateConfig}/>
            <Label updateConfig={props.updateConfig} value={props.item.label}/>
           
            <button 
                className="btn btn-outline-danger remove-item" 
                onClick={props.removeItem}
            >
                Remove
            </button>
        </div>
    );
}

export default List;
